import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=2f8fc076&scoped=true"
import script from "./CartModal.vue?vue&type=script&lang=js"
export * from "./CartModal.vue?vue&type=script&lang=js"
import style0 from "./CartModal.vue?vue&type=style&index=0&id=2f8fc076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8fc076",
  null
  
)

export default component.exports